module.exports = __webpack_public_path__ + "img/8CAEBC_3A4443_506463_DAEFEF-256px.1eb48f3e.png";